var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialFailbook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage---v2",
    transform: "translate(-1015.000000, -4290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(0.000000, 4220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social_failbook",
    transform: "translate(1015.006849, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1666667,13.2166665 L17.9833337,13.2166665 C18.2000004,13.2166665 18.3083329,13.4333337 18.3083329,13.6500004 L17.875,15.7083333 C17.875,15.8166667 17.6583342,15.9249998 17.5500008,15.9249998 L15.1666667,15.9249998 L15.1666667,23.8333333 L11.9166667,23.8333333 L11.9166667,16.0333335 L10.0750002,16.0333335 C9.85833354,16.0333335 9.75,15.925 9.75,15.7083333 L9.75,13.6500004 C9.75,13.4333337 9.85833354,13.3250002 10.0750002,13.3250002 L11.9166667,13.3250002 L11.9166667,9.75 C11.9166667,7.90833328 13.3249999,6.5 15.1666667,6.5 L18.0916675,6.5 C18.3083342,6.5 18.4166667,6.60833354 18.4166667,6.82500021 L18.4166667,9.42499979 C18.4166667,9.64166646 18.3083342,9.75 18.0916675,9.75 L15.4916669,9.75 C15.2750002,9.75 15.1666667,9.85833354 15.1666667,10.0750002 L15.1666667,13.2166665 Z",
    id: "Vector",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,23.8333333 C4.33333333,23.8333333 2.16666667,21.6666667 2.16666667,16.25 L2.16666667,9.75 C2.16666667,4.33333333 4.33333333,2.16666667 9.75,2.16666667 L16.25,2.16666667 C21.6666667,2.16666667 23.8333333,4.33333333 23.8333333,9.75 L23.8333333,16.25 C23.8333333,21.6666667 21.6666667,23.8333333 16.25,23.8333333 L9.75,23.8333333 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,0 L26,26 L0,26 L0,0 L26,0 Z",
    id: "Vector",
    opacity: 0
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFailbook);
export default __webpack_public_path__ + "static/media/social_failbook.82874bf04ced6c18423ec0ad309af6e3.svg";
export { ForwardRef as ReactComponent };